<template>
  <div class="header">
    <!-- 手机端 侧边栏按钮 -->
    <span v-if="pc_app == 'app'"
      ><i class="el-icon-s-unfold app_sidebar_btn" @click="open_sidebar"></i
    ></span>

    <div class="top_tit">
      <span v-if="kyc_icon_ok" class="back_icon"
        ><i @click="$router.push('/user_info')" class="el-icon-back"></i
      ></span>
      <span v-if="kyc_step_btn" class="back_icon"
        ><i @click="$router.push('/kyc')" class="el-icon-back"></i
      ></span>
      <span v-if="return_sup" class="back_icon"
        ><i @click="$router.go(-1)" class="el-icon-back"></i
      ></span>
      <span v-if="apply_card_info_return" class="back_icon"
        ><i @click="info_return" class="el-icon-back"></i
      ></span>
      <span class="head_width">{{ head_title }}</span>
      <span class="head_title2">{{ head_title2 }}</span>
    </div>

    <div class="top_right_box">
      <div class="top_right_box1">
        <!-- 语言切换 -->
        <el-popover
          placement="bottom"
          popper-class="top_user lan_popover"
          width="70"
          v-model="visible_lan"
          trigger="click"
        >
          <span slot="reference">
            <!-- <img class="lan_icon" v-if="lan=='ch' " src="../../assets/img/ch_icon.png" alt="">
            <img class="lan_icon" v-else-if="lan=='jp' " src="../../assets/img/jp_icon.png" alt="">
            <img class="lan_icon" v-else src="../../assets/img/GBP.png" alt=""> -->
            <span class="lan_icon" v-if="v_lan == 'ch'">简体中文</span>
            <span class="lan_icon" v-else-if="v_lan == 'jp'">日本語</span>
            <span class="lan_icon" v-else>English</span>
            <i v-if="visible_lan" class="el-icon-caret-top u_r_icon2"></i>
            <i v-else class="el-icon-caret-bottom u_r_icon2"></i>
          </span>
          <div class="u_box">
            <!-- <div @click="lang_fun('ch')"><img class="lan_list_item" src="../../assets/img/ch_icon.png" alt=""></div>
            <div @click="lang_fun('en')"><img class="lan_list_item" src="../../assets/img/GBP.png" alt=""></div>
            <div @click="lang_fun('jp')"><img class="lan_list_item" src="../../assets/img/jp_icon.png" alt=""></div> -->
            <div class="lan_list_item" @click="lang_fun('ch')">简体中文</div>
            <div class="lan_list_item" @click="lang_fun('en')">English</div>
            <div class="lan_list_item" @click="lang_fun('jp')">日本語</div>
          </div>
        </el-popover>
      </div>

      <div class="user_img">
        <!-- <img src="../../assets/img/u_img.jpg" alt=""> -->
        <img
          @click="router_fun"
          v-if="user_img_url"
          :src="user_img_url"
          alt=""
        />
        <img
          @click="router_fun"
          v-else
          src="../../assets/img/user.png"
          alt=""
        />

        <el-popover
          placement="bottom"
          popper-class="top_user"
          width="200"
          v-model="visible"
          trigger="click"
        >
          <span slot="reference">
            <i v-if="visible" class="el-icon-caret-top u_r_icon"></i>
            <i v-else class="el-icon-caret-bottom u_r_icon"></i>
          </span>
          <div class="u_box">
            <ul class="u_operation">
              <li @click="open_view_profile">
                <img src="../../assets/img/user_img1.png" alt="" />
                {{ $t("main.text1") }}
              </li>
              <li @click="open_change_password">
                <img src="../../assets/img/user_img2.png" alt="" />
                {{ $t("main.text2") }}
              </li>
              <li @click="router_kyc" v-if="userType == 1">
                <img src="../../assets/img/user_img4.png" alt="" />
                {{ $t("main.text3") }}
              </li>
            </ul>
            <ul>
              <li @click="log_out_li" class="li_log_out">
                <img src="../../assets/img/user_img3.png" alt="" />
                <span class="log_out_color">{{ $t("main.text4") }}</span>
              </li>
            </ul>
          </div>
        </el-popover>
      </div>
    </div>
    <!-- 退出登录 -->
    <el-dialog
      :visible.sync="log_out_dlg"
      custom-class="log_out_dlg_bgc"
      append-to-body
      center
      :show-close="false"
      width="480px"
    >
      <div class="log_out1">
        <img src="../../assets/img/log_out_icon.png" alt="" />
      </div>
      <div class="log_out2">
        {{ $t("main.text5") }}
      </div>
      <div class="log_out3">
        {{ $t("main.text6") }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="log_out_dlg = false" class="cancel_btn">{{
          $t("main.text7")
        }}</el-button>
        <el-button type="primary" class="confirm_btn" @click="log_out_btn">{{
          $t("main.text8")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- 联系客服 -->
    <el-dialog
      :visible.sync="service_dlg"
      custom-class="log_out_dlg_bgc"
      append-to-body
      center
      :show-close="false"
      width="480px"
    >
      <div class="log_out1">
        <img
          style="width: 35px"
          src="../../assets/img/Pigeon_icon.png"
          alt=""
        />
      </div>
      <div class="log_out2 padding1">
        {{ $t("main.text9") }}
      </div>
      <div class="log_out3 padding2">
        {{ $t("main.text10") }}
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button class="cancel_btn">Submit now</el-button> -->
        <el-button
          type="primary"
          class="confirm_btn2"
          @click="service_dlg = false"
          >{{ $t("main.text11") }}</el-button
        >
      </span>
    </el-dialog>

    <!-- 有合同 公司简称 -->
    <!-- <el-dialog
        :visible.sync="for_short_dlg"
        custom-class="log_out_dlg_bgc"
        append-to-body
        center
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="480px">
        <div class="log_out2">
          {{$t('bank_card.The_company')}}
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="for_short_skip" class="cancel_btn">{{$t('bank_card.Click_jump')}}</el-button>
        </span>
    </el-dialog> -->
  </div>
</template>

<script>
import { getUserInfo, exitLogin } from "@/api/api";
export default {
  data() {
    return {
      pc_app: this.pcormove._isMobile(),
      head_title: "",
      visible: false,
      visible_lan: false,
      user_img_url: "",
      log_out_dlg: false,
      kyc_step_btn: false,
      service_dlg: false,
      kyc_icon_ok: false,
      return_sup: false,
      head_title2: "",
      apply_card_info_return: false,

      // userType 1 主账号； 2子账号
      userType: sessionStorage.getItem("userType"),
      for_short_dlg: false,
    };
  },
  // props: {
  //   user_img_url: {
  //     type: String,
  //     default: '',
  //   }
  // },
  mounted() {
    this.set_active();
    this.get_user_info();
    // this.bus.$on("user_data",(v)=>{
    //   v;
    //   // console.log(v);
    //   this.get_user_info();
    // });
    this.bus.$on("kf_dlg", () => {
      this.service_dlg = true;
      // console.log(111);
    });
    this.head_title2 = sessionStorage.getItem("top_title_name")
      ? sessionStorage.getItem("top_title_name")
      : "";
    if (!this.user_img_url) {
      this.user_img_url = sessionStorage.getItem("avatar");
    }
    this.userType = sessionStorage.getItem("userType");
  },
  destroyed() {
    // this.bus.$off("user_data");
    this.bus.$off("kf_dlg");
  },
  methods: {
    set_active() {
      if (this.$route.path == "/") {
        this.head_title = this.$t("main.text12");
        this.kyc_step_btn = false;
        this.kyc_icon_ok = false;
      } else if (this.$route.path == "/my_transaction") {
        this.head_title = this.$t("main.text746");
        this.kyc_step_btn = false;
        this.kyc_icon_ok = false;
      } else if (this.$route.path == "/blockchain_d") {
        this.head_title = this.$t("main.text14");
        this.kyc_step_btn = false;
        this.kyc_icon_ok = false;
      } else if (this.$route.path == "/blockchain_w") {
        this.head_title = this.$t("main.text15");
        this.kyc_step_btn = false;
        this.kyc_icon_ok = false;
      } else if (this.$route.path == "/fiat_deposit") {
        this.head_title = this.$t("main.text16");
        this.kyc_step_btn = false;
        this.kyc_icon_ok = false;
      } else if (this.$route.path == "/fiat_withdrawal") {
        this.head_title = this.$t("main.text17");
        this.kyc_step_btn = false;
        this.kyc_icon_ok = false;
      } else if (this.$route.path == "/otc") {
        this.head_title = this.$t("main.text18");
        this.kyc_step_btn = false;
        this.kyc_icon_ok = false;
      } else if (this.$route.path == "/fx") {
        this.head_title = this.$t("main.text19");
        this.kyc_step_btn = false;
        this.kyc_icon_ok = false;
      } else if (this.$route.path == "/kyc") {
        this.head_title = this.$t("main.text241");
        this.kyc_step_btn = false;
        this.kyc_icon_ok = true;
      } else if (this.$route.path == "/kyc_step/kyc_step_one") {
        this.head_title = this.$t("main.text21");
        this.kyc_step_btn = true;
        this.kyc_icon_ok = false;
      } else if (this.$route.path == "/kyc_step/kyc_step_two") {
        this.head_title = this.$t("main.text22");
        this.kyc_step_btn = true;
        this.kyc_icon_ok = false;
      } else if (this.$route.path == "/kyc_step/kyc_step_three") {
        this.head_title = this.$t("main.text23");
        this.kyc_step_btn = true;
        this.kyc_icon_ok = false;
      } else if (this.$route.path == "/kyc_step/kyc_step_four") {
        this.head_title = this.$t("main.text24");
        this.kyc_step_btn = true;
        this.kyc_icon_ok = false;
      } else if (this.$route.path == "/private_b_p") {
        this.head_title = this.$t("main.text267");
        this.kyc_step_btn = false;
        this.kyc_icon_ok = false;
      } else if (this.$route.path == "/structured_p") {
        this.head_title = this.$t("main.text268");
        this.kyc_step_btn = false;
        this.kyc_icon_ok = false;
      } else if (this.$route.path == "/investment_b") {
        this.head_title = this.$t("main.text269");
        this.kyc_step_btn = false;
        this.kyc_icon_ok = false;
      } else if (this.$route.path == "/concealed_accounts") {
        this.head_title = "";
        this.kyc_step_btn = false;
        this.kyc_icon_ok = false;
      } else {
        this.head_title = "";
        this.kyc_step_btn = false;
        this.kyc_icon_ok = false;
      }

      if (
        this.$route.path.indexOf("transaction_h_info") != -1 ||
        this.$route.path.indexOf("m_m_payee_list") != -1 ||
        this.$route.path.indexOf("new_fiat") != -1 ||
        this.$route.path.indexOf("new_fiat2") != -1 ||
        this.$route.path.indexOf("m_m_addr_list") != -1 ||
        this.$route.path.indexOf("new_digital_asset") != -1 ||
        this.$route.path.indexOf("new_digital_asset2") != -1 ||
        this.$route.path.indexOf("fiat_t_h_info") != -1 ||
        this.$route.path.indexOf("my_transaction_info") != -1 ||
        this.$route.path.indexOf("digital_t_h_info") != -1 ||
        this.$route.path.indexOf("apply_card_input") != -1 ||
        this.$route.path.indexOf("top_up_history") != -1 ||
        this.$route.path.indexOf("transaction_record") != -1 ||
        this.$route.path.indexOf("bank_details") != -1 ||
        this.$route.path.indexOf("contract_management_list") != -1
      ) {
        this.return_sup = true;
      } else {
        this.return_sup = false;
      }

      if (this.$route.path.indexOf("apply_card_info") != -1) {
        this.apply_card_info_return = true;
      } else {
        this.apply_card_info_return = false;
      }
    },
    router_fun() {
      if (this.$router.currentRoute.path != "/user_info") {
        this.$router.push("/user_info");
      }
      this.visible = false;
    },
    router_kyc() {
      if (this.$router.currentRoute.path != "/kyc") {
        this.$router.push("/kyc");
      }
      this.visible = false;
    },
    get_user_info() {
      getUserInfo().then((res) => {
        if (res.data.code == 200) {
          this.user_img_url = res.data.data.avatar;
          localStorage.setItem("approve_status", res.data.data.approve_status);
          sessionStorage.setItem("u_email", res.data.data.email);
          this.haveContract = res.data.data.haveContract;
          // this.company_abbreviation = res.data.data.company_abbreviation;
          // if (this.$route.path !== '/user_info') {
          //   if(res.data.data.haveContract && !res.data.data.company_abbreviation){
          //     this.for_short_dlg = true;
          //   }
          // }
        }
      });
    },
    log_out_li() {
      this.log_out_dlg = true;
      this.visible = false;
    },
    log_out_btn() {
      exitLogin().then((res) => {
        if (res.data.code == 200) {
          // localStorage.clear();
          // sessionStorage.clear();
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("userid");
          sessionStorage.removeItem("fa_dlg");
          sessionStorage.removeItem("project_name");
          this.$store.state.login.router_true = true;
          this.$router.push("/login");
        }
      });
    },
    open_view_profile() {
      this.visible = false;
      if (this.$router.currentRoute.path != "/user_info") {
        this.$router.push("/user_info");
        setTimeout(() => {
          this.bus.$emit("open_view_profile_dlg");
        }, 100);
      } else {
        this.bus.$emit("open_view_profile_dlg");
      }
    },
    open_change_password() {
      this.visible = false;
      if (this.$router.currentRoute.path != "/user_info") {
        this.$router.push("/user_info");
        setTimeout(() => {
          this.bus.$emit("open_change_password_dlg");
        }, 100);
      } else {
        this.bus.$emit("open_change_password_dlg");
      }
    },
    open_sidebar() {
      this.bus.$emit("app_sidebar_open");
    },
    lang_fun(v) {
      localStorage.setItem("language", v);
      setTimeout(() => {
        location.reload();
      }, 100);
    },
    info_return() {
      this.bus.$emit("info_return_fun");
    },
    // for_short_skip(){
    //   this.for_short_dlg = false;
    //   if (this.$router.currentRoute.path!='/user_info') {
    //     this.$router.push('/user_info');
    //     setTimeout(() => {
    //       this.bus.$emit('open_view_profile_dlg');
    //     }, 100);
    //   }else{
    //     this.bus.$emit('open_view_profile_dlg');
    //   }
    // }
  },
  watch: {
    $route() {
      this.set_active();
      setTimeout(() => {
        this.head_title2 = sessionStorage.getItem("top_title_name")
          ? sessionStorage.getItem("top_title_name")
          : "";
      }, 0);
      // if (this.$route.path !== '/user_info') {
      //   this.get_user_info();
      // }
    },
  },
};
</script>

<style scoped>
.header {
  height: 80px;
  background: #041e35;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 40px;
}
.top_tit {
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  /* line-height: 26px; */
  height: 100%;
  display: flex;
  align-items: center;
  max-width: 80%;
}
.user_img img {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  cursor: pointer;
  margin-top: -5px;
}
.u_box ui,
.u_box li {
  list-style: none;
  cursor: pointer;
}
.u_box .u_operation {
  border-bottom: 1px solid #313131;
  padding-bottom: 10px;
}
.u_box li {
  box-sizing: border-box;
  padding: 10px 5px;
}
.u_box li img {
  width: 20px;
  vertical-align: middle;
  margin-right: 10px;
}

/* ------ */
.dlg_body {
  background: #041e35;
  color: #fff;
}
.d_body {
  box-sizing: border-box;
  padding: 40px 0;
  max-width: 420px;
  margin: auto;
}
.dlg_u_box {
  display: flex;
  align-items: center;
}
.dlg_u1 {
  width: 100px;
  height: 100px;
  border: 2px solid #deb981;
  border-radius: 50%;
}
.dlg_u2,
.dlg_u2:hover {
  background: linear-gradient(90deg, #f1c788 0.42%, #e3a84e 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border: none;
  border-radius: 4px;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  color: #04182a;
  margin-left: 40px;
  margin-bottom: 8px;
}
.dlg_u3 {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  margin-left: 40px;
}
.dlg_form {
  margin-top: 25px;
}
.dlg_form >>> .el-form-item__label {
  line-height: 30px;
  color: #fff;
  padding: 0;
}
.cancel_btn {
  color: #f1c788;
  border-color: #f1c788;
  background: transparent;
}
.confirm_btn {
  /* width: 130px; */
  background: #ff4646;
  border-color: #ff4646;
  border-radius: 4px;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  color: #ffffff;
  margin-left: 20px;
  margin-bottom: 15px;
}
/* .confirm_btn2{
  min-width: 86px;
  background: linear-gradient(90deg, #f1c788 0.42%, #e3a84e 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-color: #f1c788;
  border-radius: 4px;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  color: #04182a;
  margin-bottom: 15px;
}
.padding1{
  padding: 0 30px;
}
.padding2{
  padding: 0 27px;
} */
/* --- */
.out_box {
  text-align: center;
  font-size: 20px;
}
/* 退出弹框 */
.log_out1 img {
  width: 40px;
  display: block;
  margin: auto;
}
.log_out2 {
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  margin-top: 16px;
  text-align: center;
  word-break: break-word;
  word-wrap: break-word;
}
.log_out3 {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  opacity: 0.8;
  margin-top: 8px;
  text-align: center;
  word-break: break-word;
  word-wrap: break-word;
}
.u_r_icon {
  margin-left: 10px;
  margin-top: -30px;
  cursor: pointer;
  vertical-align: middle;
}

.li_log_out {
  margin-top: 15px;
}
.app_sidebar_btn {
  display: none;
}

/* --over-- */
.top_right_box {
  display: flex;
}
.lan_icon {
  width: 28px;
  height: 28px;
  vertical-align: middle;
  cursor: pointer;
  color: rgb(222, 185, 129);
}
.top_right_box1 {
  margin-right: 30px;
  display: flex;
  align-items: center;
}
.u_r_icon2 {
  margin-left: 8px;
  cursor: pointer;
  margin-top: 5px;
  color: rgb(222, 185, 129);
}
.lan_list_item {
  cursor: pointer;
  /* width: 28px;
  height: 28px; */
  margin: 10px auto;
  display: block;
}
.head_title2 {
  /* max-width: 70%; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

<style>
.top_user {
  color: #fff;
  font-size: 15px;
  background: #03101c;
  box-shadow: 0px 4px 8px #03101c;
  border-radius: 16px;
  border: none;
}
.top_user[x-placement^="bottom"] .popper__arrow,
.top_user[x-placement^="bottom"] .popper__arrow::after {
  display: none;
  border-bottom-color: transparent;
}
.top_user .popper__arrow {
  display: none;
}
.lan_popover {
  min-width: 70px;
  transform: translateX(-3px);
}
/* ---- */
.dlg {
  background: rgb(4, 23, 40) !important;
  color: #fff;
}
.dlg .el-dialog__title {
  color: #fff;
}
.dlg .el-dialog__headerbtn {
  left: auto;
}
.dlg .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
.dlg .el-dialog__body {
  padding: 30px 0;
}
.back_icon i {
  font-size: 20px;
  color: #fff;
  margin-right: 10px;
  cursor: pointer;
}

/* 退出 弹框 */
.log_out_dlg_bgc {
  background: #041e35 !important;
  color: #fff;
  border-radius: 16px;
}
.log_out_dlg_bgc .el-dialog__header {
  padding: 0 !important;
}
/* ---over--- */
.log_out_color {
  color: #ff4646;
}
</style>

<style scoped>
/* 手机端 */
@media screen and (max-width: 850px) {
  .header {
    padding: 0 15px;
  }
  .app_sidebar_btn {
    display: inline-block;
    font-size: 20px;
    margin-left: 10px;
  }
  .top_tit {
    flex: auto;
    padding-left: 10px;
    font-size: 18px;
  }
  .head_width {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>